<template>
    <div class="content">
        <div class="container">
            <h1 class="mb-5">
                Fulfillment
            </h1>

            <nav-fulfillment :tab="tab"/>

            <div v-if="$route.query.payment=='success'"
                 class="alert bg-white text-success border border-success p-3 mb-3">
                <strong>Thank for payment. ID
                    #{{ $route.query.id }}</strong>
            </div>
            <card-box>
                <card-title>Invoices</card-title>
                <small class="text-muted">The fulfillment order is automatically generated every 6 hours</small>


                <div class="mt-3 row d-flex">
                    <div class="col">
                        <input v-model="filter.order" type="text" class="form-control" placeholder="ID #"
                               @keyup.enter="list">
                    </div>
                    <div class="col">
                        <datepicker v-model="filter.date" :format="'yyyy-MM-dd'" :typeable="true" placeholder="Date"
                                    :input-class="'form-control'"/>
                    </div>
                    <div class="col">
                        <select class="form-control" name="status" v-model="filter.status">
                            <option value="">
                                Any Status
                            </option>
                            <option value="0">
                                UNPAID
                            </option>
                            <option value="1">
                                PAID
                            </option>
                        </select>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-dark btn-block" type="button" @click="list">
                            <i class="fi-search"/>
                        </button>
                    </div>
                </div>

                <table class="mt-3 table table-hover table-striped w-100 d-block d-md-table table-responsive">
                    <thead>
                    <tr>
                        <th>ID #</th>
                        <th>Created Date</th>
                        <th>Paid Date</th>
                        <th class="text-center">
                            Qty (Orders)
                        </th>
                        <th class="text-right">
                            Total
                        </th>
                        <th class="text-center">
                            Status
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in orders" :key="item.id">
                        <th>
                            <router-link :to="{ name: 'fulfillment_detail', params: { id: item.id }}">
                                {{ item.id }}
                            </router-link>
                        </th>
                        <td>
                            {{ item.created_at }}
                        </td>
                        <td>{{ item.updated_at == '0000-00-00 00:00:00' ? '-': item.updated_at }}</td>
                        <td class="text-center">
                            {{ item.qty }}
                        </td>
                        <td class="text-right">
                            ${{ item.payment_total }}
                        </td>

                        <td class="text-center">
                            <button :disabled="disable == 1" class="text-uppercase btn btn-block btn-sm"
                                    :class="$config.fulfillment_billing_class[item.status]"
                                    @click="paynow(item)">
                                <span v-show="disable != 1">{{ $config.fulfillment_billing[item.status] }}</span>
                                <span v-show="disable == 1">WAITING...</span>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="orders.length == 0" class="w-100 text-center p-5 ">
                    <h4 class="m-5">
                        Not Found
                    </h4>
                </div>
            </card-box>
        </div>
    </div>
</template>

<script>
    import CardBox from "@/components/CardBox";
    import Datepicker from 'vuejs-datepicker'
    import CardTitle from "@/components/CardTitle";
    import NavFulfillment from "../components/NavFulfillment";

    export default {
        name: "Fulfillment",
        components: {NavFulfillment, CardTitle, Datepicker, CardBox},
        data: function () {
            return {
                tab: 'history',
                disable: 0,
                filter: {
                    status:''
                },
                orders: [],

            }
        },
        mounted: function () {
            this.$store.commit('ACTIVE_SIDEBAR', 'fulfillment')
            this.list()
        },
        methods: {
            paynow: async function (item) {
                if (item.status == 1) return
                this.disable = 1
                await this.$http.get(this.$config.api + 'fulfillment/initcheckout/' + item.id).then(function (res) {
                    window.location.href = res.data.url
                })
            },
            list: function () {
                let vm = this
                let esc = encodeURIComponent
                let query = Object.keys(vm.filter)
                    .map(k => esc(k) + '=' + esc(vm.filter[k]))
                    .join('&')
                this.$http.get(this.$config.api + 'fulfillment?' + query).then(function (res) {
                    vm.orders = res.data.items
                })
            }
        }
    }
</script>

<style scoped>

</style>